import PropTypes from "prop-types";
import React from "react";
import styles from "./SettingsMenuSection.css";

export const SettingsMenuSection = ({ title, children, ...props }) => {
  return (
    <div {...props}>
      <div data-title className={styles.title}>
        {title}
      </div>
      {children}
    </div>
  );
};

SettingsMenuSection.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
};
